import { hide } from 'redux-modal';

/* Return saga pattern on close modal */
export const sagaPatternOnModalClose = modalName => ({ type, payload: { modal } = {} } = {}) =>
  type === hide(modalName).type && modal === modalName;
